import _ from 'lodash';

function hasPermissionForPatientFactory() {
  return function hasPermissionForPatient(user, patient, permission) {
    if (user === null) {
      return false;
    }

    if (user.isAdmin) {
      return true;
    }

    if (permission === 'EDIT_PATIENT' && patient.frozen) {
      return false;
    }

    var patientGroupIds = _.map(patient.groups, function(patientGroup) {
      return patientGroup.group.id;
    });

    var userGroups = user.groups;

    for (var i = 0; i < userGroups.length; i++) {
      var userGroup = userGroups[i];

      if (_.indexOf(patientGroupIds, userGroup.group.id) >= 0 && userGroup.hasPermission(permission)) {
        return true;
      }
    }

    return false;
  };
}

export default hasPermissionForPatientFactory;



/** WEBPACK FOOTER **
 ** ./src/app/permissions/has-permission-for-patient.js
 **/